import { createApi } from "@reduxjs/toolkit/query/react";
import { UserDTO } from "../../../types/User";
import { getBaseQuery } from "../baseQuery";

export interface UserGroupDTO {
  id?: string | null;
  accountId: number;
  name: string;
  userIds: Array<number>;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export const usersService = createApi({
  reducerPath: "usersService",
  baseQuery: getBaseQuery("aiakos"),
  tagTypes: ["Users", "UserGroups"],
  endpoints: (builder) => ({
    getUsers: builder.query<UserDTO[], { accountId: string }>({
      query: (arg) => {
        const { accountId } = arg;
        return `/api/users?account_id=${accountId}`;
      },
      providesTags: [{ type: "Users", id: "LIST" }],
    }),
    getUserById: builder.query<UserDTO, { userId: number }>({
      query: (arg) => {
        const { userId } = arg;
        return `/api/users/${userId}`;
      },
      providesTags: (_result, _error, { userId }) => [{ type: "Users", id: userId }],
    }),
    getUserGroups: builder.query<UserGroupDTO[], void>({
      query: () => `/api/user-groups`,
      providesTags: [{ type: "UserGroups", id: "LIST" }],
    }),
  }),
});

export const { useGetUsersQuery, useGetUserByIdQuery, useGetUserGroupsQuery } =
  usersService;
